import Button from 'ui/Button/Button';
import AboutContentIcon from 'ui/SVG/AboutBoardIcon';
import './Board.scss';

const Board: React.FC = (props) => (
  <div className="about-board">
    <div className="about-board__back">
      <AboutContentIcon />
    </div>
    <div className="about-board__content">
      <p className="about-board__text">
        Get set play is equipped with all of the infrastructures you need for p2p streaming. As
        a haven for gamers of all types, it is also the first decentralized p2p streaming
        platform. Gaming is everything on the Get Set Play Multiverse; the multiverse is the
        immerse space where it all happens.
      </p>
      <Button 
        title='Start'
        to="/"
        className="about-board__btn"
      />
    </div>
  </div>
);

export default Board;
